import React from 'react'

export default function ArrowDown() {
    return (
        <svg viewBox="0 0 20 13">
            <path d="M19.898 2.999L10 12.899 7.17 10.07h.001L.1 2.999 2.926.171 10 7.24l7.07-7.07z"/>
        </svg>
    )
}
